import React, { Fragment, FC, useEffect } from 'react';
import { observer, inject } from 'mobx-react';
import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import StoreModel from 'models/Index';
import { Services } from 'helpers/constants/Services';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { WithTranslation, withTranslation } from 'react-i18next';
import { RoutePaths } from 'helpers/constants/RoutePaths';
import { TouchPointerIcon } from 'assets/icons';
import IdleSwiper from 'components/IdleSwiper';


interface IdleScreenProps extends RouteComponentProps, WithTranslation { }

interface IdleScreenPropsInjected extends IdleScreenProps {
    Store: StoreModel;
}

const useStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            textDecoration: 'none',
            width: '100%',
            height: '100vh',
            padding: "10vh 10% 10vh 10%"
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        },
        swiperContainer: {
            width: '100%',
            height: '100vh', // Full height for Swiper
            overflow: 'hidden', // Hide anything overflowing
        },
        logoContainer: {
            height: '25vh',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        logo: {
            maxHeight: '25vh',

        },
        font: {
            maxHeight: '30vh',
            fontWeight: 500,
            fontSize: 36,
            fontFamily: 'Montserrat',
            color: '#050A02',
            margin: '0',
        },
        blocktouch: {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '10vh',
            height: '30vh',
            marginTop: '10vh',
        },
        blocktext: {
            display: 'flex',
            justifyContent: 'center',
            height: '5vh',
        },

    };
});

const IdleScreen: FC<IdleScreenProps> = (props) => {
    const { history, t, Store } = props as IdleScreenPropsInjected;
    const classes = useStyles();
    const logoUrl = Store.kioskLogo;
    const handleTouch = () => {
        history.push(RoutePaths.LanguageSelect);
    };

    let logoImg;
    if (logoUrl) {
        logoImg = <div className={classes.logoContainer}><img src={logoUrl} alt={'Logo'} className={classes.logo} /></div>;
    } else {
        logoImg = null;
    }

    useEffect(() => {
        Store.reset()
            .then(() => Store.peripheryStatus.check())
            .finally(() => {
                if (
                    Store.peripheryStatus.hasErrors ||
                    !Store.isRegisterEnabled
                ) {
                    history.push({
                        ...history.location,
                        pathname: RoutePaths.KioskOutOfOrder,
                    });
                }
            });
    }, [Store, history]);



    const StandartPonter = (<Link
        to={(location) => ({
            ...location,
            pathname: RoutePaths.LanguageSelect,
        })}
        className={classes.root}
    >
        <div className={classes.container}>
            {logoImg}
            <div className={classes.blocktouch}>
                <TouchPointerIcon colorType='primary' />
                {/* Bug with resetting language in componentDidMount https://github.com/i18next/react-i18next/issues/968 */}
            </div>
            <div className={classes.blocktext}>
                <p className={classes.font}>
                    {t('Touch the screen to begin', {
                        lng: Store.language,
                    })}
                </p>
            </div>
        </div>
    </Link>);

    return (
        <Fragment>
            {Store.deviceProfile.enableMarketingDemo ?
                <div className={classes.container}>
                    <div className={classes.swiperContainer}>
                        <IdleSwiper handleTouch={handleTouch} />
                    </div>
                </div>
                : StandartPonter}
        </Fragment>
    );
};

export default withTranslation()(
    withRouter(inject(Services.STORE)(observer(IdleScreen)))
);
